// @core/api/endpoints/legalentity/delete_legal_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/legalentity';

/**
 * Delete (archive) legal entity
 * Soft-deletes a legal entity by transitioning to ARCHIVED status. The record is preserved for audit and historical contract rendering. Hard delete is blocked if any signed contract references this entity.
 */
export async function DeleteLegalEntity(
  legal_entity_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:legal_entity_id`;
  requestPath = requestPath.replace(':legal_entity_id', encodeURIComponent(legal_entity_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
